import StaticPageLayout from './StaticPageLayout';

export default function ImprintPage() {
  return <StaticPageLayout title="Impressum"></StaticPageLayout>;
}
